const DATE_FIELDS = new Set(["moveDate"]);

const formatValue = (field, value) => {
  if (!value) {
    return "";
  }
  if (DATE_FIELDS.has(field)) {
    const parts = value.split("-");
    if (parts.length === 3) {
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    }
  }
  return value;
};

const initCancellationLetter = () => {
  const cancellationForm = document.querySelector(".js-cancellation-form");
  if (!cancellationForm) {
    return;
  }

  const interactivePdfUrl = cancellationForm.dataset.interactivePdfUrl || "";

  const fields = [...cancellationForm.querySelectorAll("[data-field]")];
  const fieldInputs = new Map(
    fields
      .map((input) => [input.getAttribute("data-field"), input])
      .filter(([name]) => Boolean(name))
  );

  const previewTargets = new Map();
  document.querySelectorAll("[data-preview]").forEach((target) => {
    const name = target.getAttribute("data-preview");
    if (!name) {
      return;
    }
    if (!previewTargets.has(name)) {
      previewTargets.set(name, []);
    }
    previewTargets.get(name).push(target);
  });

  const setPreview = (name, value) => {
    (previewTargets.get(name) || []).forEach((target) => {
      target.textContent = value;
    });
  };

  const joinValues = (left, right, separator) => {
    const a = (left || "").trim();
    const b = (right || "").trim();
    if (!a || !b) {
      return a || b;
    }
    return `${a}${separator}${b}`;
  };

  const combinedBindings = [
    ["providerPostal", "providerCity", "providerPostalCity", ", "],
    ["currentPostal", "currentCity", "currentPostalCity", ", "],
    ["newPostal", "newCity", "newPostalCity", ", "],
    ["providerStreet", "providerHouseNumber", "providerStreetHouse", " "],
    ["currentStreet", "currentHouseNumber", "currentStreetHouse", " "],
    ["newStreet", "newHouseNumber", "newStreetHouse", " "],
  ];

  const updateField = (field) => {
    const input = fieldInputs.get(field);
    if (!input) {
      return;
    }
    setPreview(field, formatValue(field, input.value));
  };

  const updateCombined = ([leftField, rightField, targetField, separator]) => {
    const leftValue = fieldInputs.get(leftField)?.value;
    const rightValue = fieldInputs.get(rightField)?.value;
    if (leftValue == null && rightValue == null) {
      return;
    }
    setPreview(targetField, joinValues(leftValue, rightValue, separator));
  };

  const updateByField = (changedField) => {
    updateField(changedField);
    combinedBindings.forEach((binding) => {
      if (binding[0] === changedField || binding[1] === changedField) {
        updateCombined(binding);
      }
    });
  };

  fields.forEach((input) => {
    updateByField(input.getAttribute("data-field"));
  });

  const hasAnyInputValue = () => fields.some((input) => (input.value || "").trim() !== "");

  const downloadTemplatePdf = () => {
    if (!interactivePdfUrl) {
      return;
    }
    const link = document.createElement("a");
    link.href = interactivePdfUrl;
    link.target = "_blank";
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadBtn = document.querySelector(".js-download-button");
  const inputwidgetDialog = document.querySelector(".js-inputwidget-dialog");
  const closeDialogBtn = document.querySelector(".js-inputwidget-dialog__close");
  const letter = document.querySelector(".js-cancellation-preview");

  let printRoot = null;
  let letterPlaceholder = null;

  const openSwitchDialog = () => {
    if (!inputwidgetDialog) {
      return;
    }
    if (typeof inputwidgetDialog.showModal === "function") {
      if (!inputwidgetDialog.open) {
        inputwidgetDialog.showModal();
      }
    } else {
      inputwidgetDialog.setAttribute("open", "");
    }
  };

  const closeSwitchDialog = () => {
    if (!inputwidgetDialog) {
      return;
    }
    if (typeof inputwidgetDialog.close === "function") {
      inputwidgetDialog.close();
    } else {
      inputwidgetDialog.removeAttribute("open");
    }
  };

  const beforePrint = () => {
    if (!letter || printRoot) {
      return;
    }
    printRoot = document.createElement("div");
    printRoot.className = "c-cancellation-print-root";
    letterPlaceholder = document.createComment("letter-placeholder");
    letter.parentNode.replaceChild(letterPlaceholder, letter);
    printRoot.appendChild(letter);
    document.body.appendChild(printRoot);
    document.body.classList.add("is-cancellation-printing");
  };

  const afterPrint = () => {
    if (!printRoot || !letterPlaceholder?.parentNode) {
      return;
    }
    letterPlaceholder.parentNode.replaceChild(letter, letterPlaceholder);
    document.body.removeChild(printRoot);
    document.body.classList.remove("is-cancellation-printing");
    printRoot = null;
    letterPlaceholder = null;

    openSwitchDialog();
  };

  const onInputChange = (event) => {
    const field = event.target?.getAttribute?.("data-field");
    if (!field) {
      return;
    }
    updateByField(field);
  };

  cancellationForm.addEventListener("input", onInputChange);
  cancellationForm.addEventListener("change", onInputChange);

  window.addEventListener("beforeprint", beforePrint);
  window.addEventListener("afterprint", afterPrint);

  if (downloadBtn) {
    downloadBtn.addEventListener("click", () => {
      if (!hasAnyInputValue()) {
        downloadTemplatePdf();
        openSwitchDialog();
        return;
      }

      window.print();
    });
  }

  if (closeDialogBtn && inputwidgetDialog) {
    closeDialogBtn.addEventListener("click", closeSwitchDialog);
  }

  // Close when clicking on the backdrop.
  if (inputwidgetDialog) {
    inputwidgetDialog.addEventListener("click", (event) => {
      if (event.target === inputwidgetDialog) {
        closeSwitchDialog();
      }
    });
  }
};

export { initCancellationLetter };
